import { Component } from 'react';
import PropTypes from 'prop-types';

import TextLink from 'src/components/TextLink';
import { captureException } from 'src/lib/sentry';

export class SlateErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  clearError = () => {
    this.setState({ error: null });
  };

  componentDidCatch(error, errorInfo) {
    captureException(error, {
      level: 'warning',
      extra: {
        ...errorInfo,
        source: 'SlateErrorBoundary',
      },
      tags: {
        transaction: 'SlateErrorBoundary',
      },
    });
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <div data-testid="SlateErrorBoundary">
          Oh no, something went wrong.
          <TextLink
            onClick={this.clearError}
            data-testid="SlateErrorBoundary__RerenderButton"
          >
            Rerender
          </TextLink>
        </div>
      );
    }

    return children;
  }
}

SlateErrorBoundary.propTypes = {
  children: PropTypes.node,
};

SlateErrorBoundary.defaultProps = {
  children: null,
};
